import React from "react";
import "./PatientProfileNew.css";
import NavbarNew from "../Navbar/NavbarNew";
import questionMark from "../Images/Vector.png";
import Footer from "./Footer";
import axios from "axios";
import { useState, useEffect } from "react";
import edit from "../Operator/SVGs/edit.svg";
import Sidebar from "./components/Sidebar";
import SidebarPatient from "./components/SidebarPatient";
import useIdleTimer from "../../useIdleTimer";
import log from "../../logger";
import API from "../../api";

const PatientProfile = () => {
  const [storedUserObject, setstoredUserObject] = useState({});
  const project = sessionStorage.getItem("project");
  const [physicians, setPhysicians] = useState([]);
  const [role, setRole] = useState("");

  // const storedUserObjectString = sessionStorage.getItem("userObject");
  // const storedUserObject = JSON.parse(storedUserObjectString);
  const username = storedUserObject.first_name;
  const [patient, setPatient] = useState({});
  const [isUserLoading, setIsUserLoading] = useState(true);
  // const patient =
  //   role === "Patient"
  //     ? storedUserObject
  //     : JSON.parse(sessionStorage.getItem("Patient")) || {};

  // const [editedPatient, setEditedPatient] = useState({ patient });
  // const [prevPatient, setPrevPatient] = useState({ patient });
  const [editedPatient, setEditedPatient] = useState({});
  const [prevPatient, setPrevPatient] = useState({});

  const [, setIsErrorOpen] = useState(false);
  const [, setErrorMessage] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [errors, setErrors] = useState({
    mobile_number: "",
    last_name: "",
    first_name: "",
    address_1: "",
    city: "",
    state: "",
    zip_code: "",
  });

  const [isDropdownOpen, setIsDropdownOpen] = useState({
    physician: false,
    status: false,
    type: false,
    gender: false,
    indication: false,
    race: false,
  });

  const [selectedValues, setSelectedValues] = useState({
    physician: prevPatient.physician_name || "",
    status: prevPatient.status || "",
    type: prevPatient.patient_type || "",
    gender: prevPatient.gender || "",
    race: prevPatient.race || "",
    indication: Array.isArray(prevPatient.indication)
      ? prevPatient.indication
      : [],
  });

  const states = [
    { code: "AL", name: "Alabama" },
    { code: "AK", name: "Alaska" },
    { code: "AZ", name: "Arizona" },
    { code: "AR", name: "Arkansas" },
    { code: "CA", name: "California" },
    { code: "CO", name: "Colorado" },
    { code: "CT", name: "Connecticut" },
    { code: "DE", name: "Delaware" },
    { code: "FL", name: "Florida" },
    { code: "GA", name: "Georgia" },
    { code: "HI", name: "Hawaii" },
    { code: "ID", name: "Idaho" },
    { code: "IL", name: "Illinois" },
    { code: "IN", name: "Indiana" },
    { code: "IA", name: "Iowa" },
    { code: "KS", name: "Kansas" },
    { code: "KY", name: "Kentucky" },
    { code: "LA", name: "Louisiana" },
    { code: "ME", name: "Maine" },
    { code: "MD", name: "Maryland" },
    { code: "MA", name: "Massachusetts" },
    { code: "MI", name: "Michigan" },
    { code: "MN", name: "Minnesota" },
    { code: "MS", name: "Mississippi" },
    { code: "MO", name: "Missouri" },
    { code: "MT", name: "Montana" },
    { code: "NE", name: "Nebraska" },
    { code: "NV", name: "Nevada" },
    { code: "NH", name: "New Hampshire" },
    { code: "NJ", name: "New Jersey" },
    { code: "NM", name: "New Mexico" },
    { code: "NY", name: "New York" },
    { code: "NC", name: "North Carolina" },
    { code: "ND", name: "North Dakota" },
    { code: "OH", name: "Ohio" },
    { code: "OK", name: "Oklahoma" },
    { code: "OR", name: "Oregon" },
    { code: "PA", name: "Pennsylvania" },
    { code: "RI", name: "Rhode Island" },
    { code: "SC", name: "South Carolina" },
    { code: "SD", name: "South Dakota" },
    { code: "TN", name: "Tennessee" },
    { code: "TX", name: "Texas" },
    { code: "UT", name: "Utah" },
    { code: "VT", name: "Vermont" },
    { code: "VA", name: "Virginia" },
    { code: "WA", name: "Washington" },
    { code: "WV", name: "West Virginia" },
    { code: "WI", name: "Wisconsin" },
    { code: "WY", name: "Wyoming" },
  ];

  const [selectedState, setSelectedState] = useState(
    editedPatient.state || "Select State"
  );
  const [isStateDropdownOpen, setIsStateDropdownOpen] = useState(false);

  const handleStateSelect = (stateCode) => {
    setSelectedState(stateCode);
    setEditedPatient((prevPatient) => ({
      ...prevPatient,
      state: stateCode,
    }));
    setIsStateDropdownOpen(false);
  };

  const statuses = [
    "Accepted",
    "Rejected",
    "Scanned",
    "Withdraw",
    "On Hold",
    "Screened",
    "Pending Screening",
  ];
  const types = ["Volunteer", "Patient"];
  const genders = ["Male", "Female", "Other"];
  const races = [
    "Asian",
    "Black or African American",
    "Hispanic or Latino",
    "American Indian or Alaska Native",
    "White",
    "Native Hawaiian or Other Pacific Islander",
    "Two or More Races",
    "N/A",
    "Other",
  ];
  const injuryTypes = [
    "Aneurysm",
    "Stroke",
    "Traumatic Brain Injury",
    "Malformation",
    "Brain Tumor",
    "Hemorrhage",
    "Pineal Cyst",
    "Meningioma",
    "Hydrocephalus",
    "Glioblastoma",
    "Cerebral Palsy",
    "Epilepsy",
    "Cavernous hemangioma",
    "Unclear",
    "AVM",
    "Meningitis",
    "Other",
  ];
  const handleIdle = () => {
    console.log("User is idle, logging out...");
    window.location.href = "/";
  };
  useIdleTimer(handleIdle, 1.2e6);

  const fetchUserRole = async () => {
    try {
      const response = await axios.get("/common/api/get_user_role/", {
        withCredentials: true,
      });
      setRole(response.data.role);
    } catch (error) {
      log.error("Error fetching user role", {
        endpoint: "/common/api/get_user_role/",
        method: "GET",
        project: project,
        response_status: 401,
        role: role,
        error_message: "Error fetching user role",
        // error_stack: error.response?.data || error.message
      });
    }
  };

  const fetchPatient = async () => {
    try {
      const project = sessionStorage.getItem("project");
      const response = await API.get("/patient/get_patient_session/", {
        headers: {
          project: project,
          "Content-Type": "application/json",
        },
      });
      let rawdata = response.data.patient.replace(/'/g, '"');
      setPatient(JSON.parse(rawdata) || {});
    } catch (error) {
      log.error("Error fetching patient", {
        endpoint: "/patient/get_patient_session/",
        method: "GET",
        project: project,
        response_status: 401,
        role: role,
        error_message: "Error fetching patient",
      });
    } finally {
      setIsUserLoading(false);
    }
  };

  const fetchUser = async () => {
    try {
      const response = await axios.get("/common/api/get_user/", {
        withCredentials: true,
      });
      setstoredUserObject(response.data.user_object);
    } catch (error) {
      log.error("Error fetching user", {
        endpoint: "/common/api/get_user/",
        method: "GET",
        project: project,
        response_status: 401,
        role: role,
        error_message: "Error fetching user",
        // error_stack: error.response?.data || error.message
      });
    } finally {
      setIsUserLoading(false);
    }
  };

  const [dataFetched, setDataFetched] = useState(false);
  const otherSelected =
    Array.isArray(selectedValues.indication) &&
    selectedValues.indication.some((v) => v?.toLowerCase?.() === "other");

  // const notesText =
  //   typeof selectedValues.notes === "string" ? selectedValues.notes : "";

  const [notesText, setNotesText] = useState("");
  const savedNotesPresent =
    Array.isArray(prevPatient.notes) && prevPatient.notes.length > 0;

  const notesPresent = notesText.trim().length > 0;

  const otherNeedsNotes = otherSelected && !notesPresent;

  useEffect(() => {
    const fetchData = async () => {
      await fetchUserRole();
      await fetchUser();
      setDataFetched(true);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (dataFetched && role && patient?.email) {
      handleGetPatientInfo();
    }
  }, [role, patient]);

  useEffect(() => {
    if (role === "Patient" && storedUserObject.email) {
      setPatient(storedUserObject);
    } else {
      if (role) {
        fetchPatient();
      }
      // setPatient(JSON.parse(sessionStorage.getItem("Patient")) || {});
    }
  }, [role, storedUserObject]);

  const handleDropdownSelect = (key, value) => {
    // If the key is "indication", handle multiple selections
    if (key === "indication") {
      setSelectedValues((prevValues) => {
        const newIndicationSet = new Set([...prevValues.indication, value]);

        return {
          ...prevValues,
          [key]: Array.from(newIndicationSet),
        };
      });

      setPrevPatient((prevPatient) => {
        const newIndication = prevPatient.indication.includes(value)
          ? prevPatient.indication.filter((item) => item !== value)
          : [...prevPatient.indication, value];

        return {
          ...prevPatient,
          [key]: newIndication,
        };
      });

      setEditedPatient((prevPatient) => {
        const newIndication = prevPatient.indication.includes(value)
          ? prevPatient.indication.filter((item) => item !== value)
          : [...prevPatient.indication, value];

        return {
          ...prevPatient,
          indication: newIndication,
        };
      });
    } else {
      setSelectedValues((prevValues) => ({
        ...prevValues,
        [key]: value,
      }));

      setPrevPatient((prevPatient) => ({
        ...prevPatient,
        [key === "physician"
          ? "physician_name"
          : key === "type"
          ? "patient_type"
          : key]: value,
      }));

      setEditedPatient((prevPatient) => ({
        ...prevPatient,
        [key === "physician"
          ? "physician_name"
          : key === "type"
          ? "patient_type"
          : key]: value,
      }));

      setIsDropdownOpen((prevOpen) => ({
        ...prevOpen,
        [key]: false,
      }));
    }
  };

  const toggleDropdown = (key) => {
    setIsDropdownOpen((prevOpen) => ({
      ...prevOpen,
      [key]: !prevOpen[key],
    }));
  };
  const getToken = () => {
    return sessionStorage.getItem(
      role === "Admin"
        ? "admin_token"
        : role === "MRI-Tech" || role === "Physician" || role === "Nurse"
        ? "operator_token"
        : role === "Patient"
        ? "patient_token"
        : null
    );
  };

  const hasErrors = Object.values(errors).some((error) => error !== "");

  const disableSave = hasErrors || otherNeedsNotes;

  const handleGetPhysicians = async (e) => {
    try {
      const project = sessionStorage.getItem("project");
      const response = await API.get(`/operator/get_all_physicians/`, {
        headers: {
          project: project,
          role,
        },
      });

      if (response.status === 200) {
        setPhysicians(response.data.operators);
        log.error("Failed to fetch physicians", {
          endpoint: "/operator/get_all_physicians/",
          method: "GET",
          project: project,
          response_status: 200,
          role: role,
        });
      } else {
        log.error("Failed to fetch physicians", {
          endpoint: "/operator/get_all_physicians/",
          method: "GET",
          project: project,
          // response_status: response.status,
          role: role,
          error_message: "Error fetching user",
        });
        setErrorMessage(
          `Failed to fetch physicians. Status: ${response.status}`
        );
        setIsErrorOpen(true);
      }
    } catch (error) {
      setErrorMessage(
        "An error occurred while fetching the physicians. Please try again."
      );
      setIsErrorOpen(true);
      log.error("Failed to fetch physicians", {
        endpoint: "/operator/get_all_physicians/",
        method: "GET",
        project: project,
        response_status: 500,
        role: role,
        error_message: "Error fetching user",
        // error_stack: error.response?.data || error.message
      });
    }
  };

  const handleEdit = (e) => {
    e.preventDefault();
    setEditedPatient(prevPatient); // important
    setSelectedState(prevPatient.state || "Select State");
    setIsEditing(true);
  };

  useEffect(() => {
    if (isEditing && role !== "Patient") {
      handleGetPhysicians();
    }
  }, [isEditing]);
  const formatDate = (dob) => {
    if (!dob) return "";

    // Mongo extended JSON
    if (dob.$date) {
      return new Date(dob.$date).toLocaleDateString();
    }

    // ISO string or YYYY-MM-DD
    if (typeof dob === "string") {
      const date = new Date(dob);
      return isNaN(date) ? "Invalid Date" : date.toLocaleDateString();
    }

    // JS Date object
    if (dob instanceof Date) {
      return dob.toLocaleDateString();
    }

    return "Invalid Date";
  };

  useEffect(() => {
    if (!isEditing) return;
    if (isEditing) {
      setSelectedValues({
        physician: prevPatient.physician_name || "",
        status: prevPatient.status || "",
        type: prevPatient.patient_type || "",
        gender: prevPatient.gender || "",
        race: prevPatient.race || "",
        indication: Array.isArray(prevPatient.indication)
          ? prevPatient.indication
          : [],
      });

      const lastNote =
        Array.isArray(prevPatient.notes) && prevPatient.notes.length > 0
          ? prevPatient.notes[prevPatient.notes.length - 1]
          : "";

      setNotesText("");
    }
  }, [isEditing, prevPatient]);

  const handleLogout = async () => {
    await axios.post("/operator/logout/", {}, { withCredentials: true });
    sessionStorage.clear();
  };

  const handleGetPatientInfo = async () => {
    setIsLoading(true);
    try {
      const response = await API.get(
        `/operator/get_patient_info/${patient.patient_id}`,
        {
          headers: {
            project,
          },
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setEditedPatient(response.data.patient);

        setPrevPatient(response.data.patient);
        setIsLoading(false);
        log.info("Successfully fetched Patient", {
          endpoint: `/operator/get_patient_info/${patient.patient_id}`,
          method: "GET",
          project: project,
          response_status: 200,
          role: role,
        });
      } else {
        log.error("Failed to fetch Patient", {
          endpoint: `/operator/get_patient_info/${patient._id}`,
          method: "GET",
          project: project,
          // response_status: response.status,
          role: role,
          error_message: "Failed to fetch Patient",
        });
      }
    } catch (error) {
      setErrorMessage(
        "An error occurred while fetching the patient profile. Please try again."
      );
      setIsErrorOpen(true);
      log.error("Failed to fetch the patient", {
        endpoint: "/operator/get_patient_info/",
        method: "GET",
        project: project,
        response_status: 500,
        role: role,
        error_message: "Error fetching user",
        // error_stack: error.response?.data || error.message
      });
    }
  };

  // useEffect(() => {
  //   handleGetPatientInfo();
  // }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let error = "";

    switch (name) {
      case "mobile_number":
        if (!isValidMobileNumber(value)) {
          error = "Invalid mobile number";
        }
        break;
      case "last_name":
        if (value.trim() === "") {
          error = "Last name is required";
        }
        break;
      case "mrn_number":
        if (value.trim() === "") {
          error = "MRN number is required";
        }
        break;
      case "first_name":
        if (value.trim() === "") {
          error = "First name is required";
        }
        break;
      case "address_1":
        if (value.trim() === "") {
          error = "Address is required";
        }
        break;
      case "city":
        if (value.trim() === "") {
          error = "City is required";
        }
        break;
      case "state":
        if (value === "State") {
          error = "State is required";
        }
        break;
      case "email":
        if (!isValidEmail(value)) {
          error = "Invalid Email";
        }
        break;
      case "zip_code":
        if (value.trim() === "") {
          error = "Zip code is required";
        } else if (!isValidZipCode(value)) {
          error = "Invalid Zip code";
        }
        break;
      default:
        break;
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: error,
    }));

    setEditedPatient((prevPatient) => ({
      ...prevPatient,
      [name]: value,
    }));
  };
  const handleDropdownChange = (e) => {
    const { name, value } = e.target;

    setEditedPatient((prevPatient) => {
      const updatedPatient = { ...prevPatient, [name]: value };

      // Ensure all date fields are present before formatting
      if (updatedPatient.day && updatedPatient.month && updatedPatient.year) {
        updatedPatient.dob = `${editedPatient.month.padStart(
          2,
          "0"
        )}-${editedPatient.day.padStart(2, "0")}-${editedPatient.year}`;
      }

      return updatedPatient;
    });
  };

  const isValidMobileNumber = (number) => {
    return /^\d{10}$/.test(number);
  };
  const isValidZipCode = (number) => {
    return /^\d{5}$/.test(number);
  };
  const isValidEmail = (email) => {
    return /^(?!\.)[\w.-]+(\.[\w.-]+)*@[a-zA-Z\d-]+(\.[a-zA-Z\d-]+)*(\.[a-zA-Z]{2,})$/.test(
      email
    );
  };

  const PhysicianField = (
    <div className="patient-row-details">
      <span className="label">Physician</span>
      <span className="colon">:</span>
      <span className="value">{prevPatient.physician_name || ""}</span>
    </div>
  );

  const handleSave = async () => {
    const hasAnyErrors = Object.values(errors).some((error) => error !== "");

    const trimmed = notesText.trim();
    const updatedNotes =
      trimmed.length > 0
        ? [
            ...(Array.isArray(prevPatient.notes) ? prevPatient.notes : []),
            trimmed,
          ]
        : Array.isArray(prevPatient.notes)
        ? prevPatient.notes
        : [];

    // Optional: enforce "Other requires notes" at save-time too
    const otherSelected =
      Array.isArray(selectedValues?.indication) &&
      selectedValues.indication.some((v) => v?.toLowerCase?.() === "other");
    const otherNeedsNotes = otherSelected && trimmed.length === 0;

    if (hasAnyErrors || otherNeedsNotes) {
      setEditedPatient((prev) => ({
        ...prev,
        first_name: errors.first_name ? "" : prev.first_name,
        last_name: errors.last_name ? "" : prev.last_name,
        mobile_number: errors.mobile_number ? "" : prev.mobile_number,
        mrn_number: errors.mrn_number ? "" : prev.mrn_number, // ✅ fix
      }));
      return; // ✅ don't call API if invalid
    }

    // ✅ Actually include updated notes in the payload
    const patientToSave = {
      ...editedPatient,
      notes: updatedNotes,
      // if indication is being edited via selectedValues, include it too:
      // indication: selectedValues.indication,
    };

    try {
      const updateResponsePatient = await API.post(
        `/operator/update_patients/`,
        { editedPatient: patientToSave },
        { headers: { project, role } }
      );

      if (updateResponsePatient.status === 200) {
        setIsEditing(false);
        setNotesText(""); // ✅ clear draft

        const updatedResponse = await API.get(
          `/operator/get_patient_info/${patient.patient_id}`,
          { headers: { project } }
        );

        if (updatedResponse.status === 200) {
          setEditedPatient(updatedResponse.data.patient);
          setPrevPatient(updatedResponse.data.patient);
        } else {
          setErrorMessage(
            "An error occurred while saving the patient information. Please try again."
          );
          setIsErrorOpen(true);
        }
      }
    } catch (error) {
      setErrorMessage(
        "An error occurred while saving the patient information. Please try again."
      );
      setIsErrorOpen(true);

      log.error("Error updating user", {
        endpoint: "/operator/update_patients/",
        method: "POST",
        project,
        role,
        response_status: error?.response?.status ?? 500,
        error_message: error?.response?.data ?? error?.message,
      });
    }
  };

  const handleCancel = () => {
    setEditedPatient(prevPatient);
    setErrors({
      mobile_number: "",
      last_name: "",
      first_name: "",
      address_1: "",
      city: "",
      state: "",
      zip_code: "",
      email: "",
    });
    setNotesText("");
    setIsEditing(false);
  };

  const calculateAge = (dob) => {
    if (!dob || !dob.$date) return ""; // Ensure dob.$date exists

    const birthDate = new Date(dob.$date);
    if (isNaN(birthDate.getTime())) return "Invalid Date"; // Handle invalid date formats

    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if birthday hasn't occurred yet this year
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  };

  return (
    <div className="page-body">
      {!isUserLoading && <NavbarNew username={username} />}

      <div className="page-layout">
        {role === "Patient" ? <SidebarPatient /> : <Sidebar />}

        <div className="main-content">
          {/* Header */}
          <div className="patient-list-container">
            <div className="first-line">
              <div className="title-container">
                <h2 className="inner-page-title">Profile</h2>
                <div className="tooltip-container">
                  <img
                    src={questionMark}
                    alt="info-icon"
                    className="info-icon"
                  />
                  <span className="tooltip-text">
                    View patient profile here
                  </span>
                </div>
              </div>
            </div>
          </div>

          {isLoading ? (
            <div
              className="loading-spinner-overlay"
              data-testid="loading-spinner-overlay"
            >
              <div className="bouncing-loader">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <div className="patient-profile-container">
              <div className="middle-line">
                <div className="profile-title-container">
                  <div className="profile-name-block">
                    <h2 className="inner-page-title">
                      {prevPatient.first_name} {prevPatient.last_name}
                    </h2>
                  </div>

                  <p className="registration-status">
                    Registration status: {prevPatient.register_status}
                  </p>
                </div>

                {isEditing ? (
                  <div className="form-buttons-edit-profile">
                    <button
                      type="button"
                      className="edit-profile-cancel"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="edit-profile"
                      onClick={handleSave}
                      disabled={disableSave}
                    >
                      <p>Save</p>{" "}
                    </button>
                  </div>
                ) : (
                  <div className="form-buttons-edit">
                    <button onClick={handleEdit} className="edit-profile">
                      <p>Edit</p>{" "}
                      <img src={edit} alt="logo" className="edit-svg" />
                    </button>
                  </div>
                )}
              </div>
              {/* Separate Boxes */}
              <div className="separate-boxes">
                {/* Left Column */}

                {role !== "Patient" && (
                  <div className="box-column-1">
                    <div className="box">
                      <span className="label">MRN Number</span>
                      <span className="colon">:</span>
                      <span className="value">
                        {isEditing && role == "SuperAdmin" ? (
                          <input
                            type="text"
                            name="mrn_number"
                            value={editedPatient.mrn_number}
                            className={`input-edit input-width${
                              errors.mrn_number ? "input-error" : ""
                            }`}
                            onChange={handleInputChange}
                          />
                        ) : (
                          prevPatient.mrn_number
                        )}
                      </span>
                    </div>

                    <div className="box">
                      <span className="label">Email</span>
                      <span className="colon">:</span>
                      <span className="value">
                        {isEditing && role == "Patient" ? (
                          <>
                            <input
                              type="email"
                              name="email"
                              value={editedPatient.email}
                              onChange={handleInputChange}
                              className={`input-edit input-width${
                                errors.email ? "input-error" : ""
                              }`}
                              placeholder="Enter email"
                            />
                            {errors.email && (
                              <div className="error-message">
                                {errors.email}
                              </div>
                            )}
                          </>
                        ) : (
                          prevPatient.email
                        )}
                      </span>
                    </div>
                  </div>
                )}
                {role !== "Patient" && (
                  <div
                    className={
                      role === "Patient" ? "box full-width" : "box-column-2"
                    }
                  >
                    {/* Right Column */}
                    {role !== "Patient" && (
                      <div
                        className={
                          role === "Patient" ? "box full-width" : "box"
                        }
                      >
                        <span className="label">Physician</span>
                        <span className="colon">:</span>
                        <span className="value">
                          {isEditing && role !== "Patient" ? (
                            <div className="custom-dropdown-container status-dropdown">
                              <div
                                className="custom-dropdown-header"
                                onClick={() => toggleDropdown("physician")}
                              >
                                {selectedValues.physician || "Select Physician"}
                                <span
                                  className={`custom-dropdown-arrow ${
                                    isDropdownOpen.physician ? "open" : ""
                                  }`}
                                >
                                  ▼
                                </span>
                              </div>
                              {isDropdownOpen.physician && (
                                <ul className="custom-dropdown-list">
                                  {physicians.map((physician) => (
                                    <li
                                      key={physician.provider_id}
                                      onClick={() =>
                                        handleDropdownSelect(
                                          "physician",
                                          `${physician.first_name} ${physician.last_name}`
                                        )
                                      }
                                      className={`custom-dropdown-item ${
                                        selectedValues.physician ===
                                        `${physician.first_name} ${physician.last_name}`
                                          ? "selected"
                                          : ""
                                      }`}
                                    >
                                      {physician.first_name}{" "}
                                      {physician.last_name}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ) : (
                            prevPatient.physician_name || ""
                          )}
                        </span>
                      </div>
                    )}
                    {role !== "Patient" && (
                      <div className="box">
                        <span className="label">Type</span>
                        <span className="colon">:</span>
                        <span className="value">
                          {isEditing ? (
                            <div className="custom-dropdown-container">
                              <div
                                className="custom-dropdown-header"
                                onClick={() => toggleDropdown("type")}
                              >
                                {selectedValues.type || "Select Type"}
                                <span
                                  className={`custom-dropdown-arrow ${
                                    isDropdownOpen.type ? "open" : ""
                                  }`}
                                >
                                  ▼
                                </span>
                              </div>
                              {isDropdownOpen.type && (
                                <ul className="custom-dropdown-list">
                                  {types.map((type) => (
                                    <li
                                      key={type}
                                      onClick={() =>
                                        handleDropdownSelect("type", type)
                                      }
                                      className={`custom-dropdown-item ${
                                        selectedValues.type === type
                                          ? "selected"
                                          : ""
                                      }`}
                                    >
                                      {type}
                                    </li>
                                  ))}
                                </ul>
                              )}
                            </div>
                          ) : (
                            prevPatient.patient_type || ""
                          )}
                        </span>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="split-details">
                {/* Left Section */}
                <div className="profile-section">
                  {role === "Patient" && PhysicianField}

                  {/* Mobile Number */}
                  <div className="patient-row-details">
                    <span className="label">Mobile Number</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role == "Patient" ? (
                        <>
                          <input
                            type="text"
                            name="mobile_number"
                            value={editedPatient.mobile_number}
                            onChange={handleInputChange}
                            className={`input-edit input-width${
                              errors.mobile_number ? "input-error" : ""
                            }`}
                            placeholder="Enter mobile number"
                          />
                          {errors.mobile_number && (
                            <div className="error-message">
                              {errors.mobile_number}
                            </div>
                          )}
                        </>
                      ) : (
                        prevPatient.mobile_number
                      )}
                    </span>
                  </div>
                  {/* Race Dropdown */}
                  <div className="patient-row-details">
                    <span className="label">Race</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role == "Patient" ? (
                        <div className="custom-dropdown-container">
                          <div
                            className="custom-dropdown-header"
                            onClick={() => toggleDropdown("race")}
                          >
                            {selectedValues.race || "Select Race"}
                            <span
                              className={`custom-dropdown-arrow ${
                                isDropdownOpen.race ? "open" : ""
                              }`}
                            >
                              ▼
                            </span>
                          </div>
                          {isDropdownOpen.race && (
                            <ul className="custom-dropdown-list">
                              {races.map((race) => (
                                <li
                                  key={race}
                                  onClick={() =>
                                    handleDropdownSelect("race", race)
                                  }
                                  className={`custom-dropdown-item ${
                                    selectedValues.race === race
                                      ? "selected"
                                      : ""
                                  }`}
                                >
                                  {race}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ) : (
                        prevPatient.race || ""
                      )}
                    </span>
                  </div>

                  {/* Age */}
                  <div className="patient-row-details">
                    <span className="label">DOB</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role == "Patient" ? (
                        <>
                          {/* Month Dropdown */}
                          <select
                            name="month"
                            value={editedPatient.month || ""}
                            onChange={handleDropdownChange}
                            className={`custom-dropdown-header-date${
                              errors.dob ? " dropdown-error" : ""
                            }`}
                          >
                            <option value="" disabled>
                              MM
                            </option>
                            <span className="custom-dropdown-arrow">▼</span>
                            {Array.from({ length: 12 }, (_, i) => (
                              <option key={i + 1} value={i + 1}>
                                {String(i + 1).padStart(2, "0")}
                              </option>
                            ))}
                          </select>

                          {/* Day Dropdown */}
                          <select
                            name="day"
                            value={editedPatient.day || ""}
                            onChange={handleDropdownChange}
                            className={`custom-dropdown-header-date${
                              errors.dob ? " dropdown-error" : ""
                            }`}
                          >
                            <option value="" disabled>
                              DD
                            </option>
                            <span className="custom-dropdown-arrow">▼</span>
                            {Array.from({ length: 31 }, (_, i) => (
                              <option key={i + 1} value={i + 1}>
                                {String(i + 1).padStart(2, "0")}
                              </option>
                            ))}
                          </select>

                          {/* Year Dropdown */}
                          <select
                            name="year"
                            value={editedPatient.year || ""}
                            onChange={handleDropdownChange}
                            className={`custom-dropdown-header-date${
                              errors.dob ? " dropdown-error" : ""
                            }`}
                          >
                            <option value="" disabled>
                              YYYY
                            </option>
                            <span className="custom-dropdown-arrow">▼</span>
                            {Array.from(
                              { length: 100 },
                              (_, i) => new Date().getFullYear() - i
                            ).map((year) => (
                              <option key={year} value={year}>
                                {year}
                              </option>
                            ))}
                          </select>

                          {errors.dob && (
                            <div className="error-message">{errors.dob}</div>
                          )}
                        </>
                      ) : (
                        formatDate(prevPatient.dob) || ""
                      )}
                    </span>
                  </div>
                  {role !== "Patient" && (
                    <div className="patient-row-details">
                      <span className="label">Age</span>
                      <span className="colon">:</span>
                      <span className="value">
                        {prevPatient.age
                          ? `${prevPatient.age} years old`
                          : prevPatient.dob
                          ? `${calculateAge(prevPatient.dob)} years old`
                          : ""}
                      </span>
                    </div>
                  )}

                  {/* Gender Dropdown */}
                  <div className="patient-row-details">
                    <span className="label">Gender</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role == "Patient" ? (
                        <div className="custom-dropdown-container">
                          <div
                            className="custom-dropdown-header"
                            data-testid="gender-dropdown-header"
                            onClick={() => toggleDropdown("gender")}
                          >
                            {selectedValues.gender || "Select Gender"}
                            <span className="custom-dropdown-arrow">▼</span>
                          </div>
                          {isDropdownOpen.gender && (
                            <ul className="custom-dropdown-list">
                              {genders.map((gender) => (
                                <li
                                  key={gender}
                                  onClick={() =>
                                    handleDropdownSelect("gender", gender)
                                  }
                                  className={`custom-dropdown-item ${
                                    selectedValues.gender === gender
                                      ? "selected"
                                      : ""
                                  }`}
                                >
                                  {gender}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ) : (
                        prevPatient.gender || ""
                      )}
                    </span>
                  </div>

                  {/* Address */}
                  <div className="patient-row-details">
                    <span className="label">Address</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role == "Patient" ? (
                        <div className="address-container">
                          <input
                            type="text"
                            name="address_1"
                            placeholder="Address Line 1"
                            value={editedPatient.address_1}
                            onChange={handleInputChange}
                            className="input-edit"
                          />
                          <input
                            type="text"
                            name="city"
                            placeholder="City"
                            value={editedPatient.city}
                            onChange={handleInputChange}
                            className="input-edit"
                          />
                          <div className="custom-dropdown-container">
                            <div
                              className="custom-dropdown-header"
                              onClick={() =>
                                setIsStateDropdownOpen(!isStateDropdownOpen)
                              }
                            >
                              {selectedState || "Select State"}
                              <span className="custom-dropdown-arrow">
                                {isStateDropdownOpen ? "▲" : "▼"}
                              </span>
                            </div>
                            {isStateDropdownOpen && (
                              <ul className="custom-dropdown-list">
                                {states.map((state) => (
                                  <li
                                    key={state.code}
                                    onClick={() =>
                                      handleStateSelect(state.code)
                                    }
                                    className={`custom-dropdown-item ${
                                      selectedState === state.code
                                        ? "selected"
                                        : ""
                                    }`}
                                  >
                                    {state.name}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>

                          <input
                            type="text"
                            name="zip_code"
                            placeholder="Zip Code"
                            value={editedPatient.zip_code}
                            onChange={handleInputChange}
                            className="input-edit"
                          />
                        </div>
                      ) : (
                        (prevPatient.address_1 ||
                          prevPatient.city ||
                          prevPatient.state) && (
                          <>
                            {prevPatient.address_1 && prevPatient.address_1}{" "}
                            {prevPatient.city && prevPatient.city}{" "}
                            {prevPatient.state && prevPatient.state}
                          </>
                        )
                      )}
                    </span>
                  </div>
                </div>

                {/* Right Section */}
                <div className="profile-section">
                  {/* Email */}
                  <div className="patient-row-details">
                    <span className="label">Status</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role !== "Patient" ? (
                        <div className="custom-dropdown-container status-dropdown">
                          <div
                            className="custom-dropdown-header"
                            onClick={() => toggleDropdown("status")}
                          >
                            {selectedValues.status || "Select Status"}
                            <span
                              className={`custom-dropdown-arrow ${
                                isDropdownOpen.status ? "open" : ""
                              }`}
                            >
                              ▼
                            </span>
                          </div>
                          {isDropdownOpen.status && (
                            <ul className="custom-dropdown-list">
                              {statuses.map((status) => (
                                <li
                                  key={status}
                                  onClick={() =>
                                    handleDropdownSelect("status", status)
                                  }
                                  className={`custom-dropdown-item ${
                                    selectedValues.status === status
                                      ? "selected"
                                      : ""
                                  }`}
                                >
                                  {status}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      ) : (
                        prevPatient.status
                      )}
                    </span>
                  </div>

                  {/* Indication Dropdown */}
                  <div className="patient-row-details">
                    <span className="label">Indication</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role !== "Patient" ? (
                        <div className="InEdit">
                          <div className="valueEdit">
                            <div className="indications-container">
                              {Array.isArray(prevPatient.indication) &&
                              prevPatient.indication.length > 0 ? (
                                <span className="indications-text">
                                  {prevPatient.indication.join(", ")}
                                </span>
                              ) : (
                                <span className="empty-text">
                                  No indications added
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="custom-dropdown-container">
                            <div
                              className="custom-dropdown-header"
                              onClick={(e) => toggleDropdown("indication")}
                            >
                              {Array.isArray(selectedValues.indication) &&
                              selectedValues.indication.length > 0
                                ? selectedValues.indication.join(", ")
                                : "Select Indication"}
                              <span
                                className={`custom-dropdown-arrow ${
                                  isDropdownOpen.gender ? "open" : ""
                                }`}
                              >
                                ▼
                              </span>
                            </div>
                            {isDropdownOpen.indication && (
                              <ul className="custom-dropdown-list">
                                {injuryTypes.map((injury) => (
                                  <li
                                    key={injury}
                                    onClick={() =>
                                      handleDropdownSelect("indication", injury)
                                    }
                                    className={`custom-dropdown-item ${
                                      selectedValues.indication.includes(injury)
                                        ? "selected"
                                        : ""
                                    }`}
                                  >
                                    {injury}
                                  </li>
                                ))}
                              </ul>
                            )}
                          </div>
                          {otherSelected && (
                            <div className="other-warning">
                              * If you select <b>Other</b>, please add details
                              in <b>Notes</b> to save.
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="indications-container">
                          {Array.isArray(prevPatient.indication) &&
                          prevPatient.indication.length > 0 ? (
                            prevPatient.indication.map((indication, index) => (
                              <div key={index} className="indication-item">
                                {indication}
                              </div>
                            ))
                          ) : (
                            <span className="empty-text">
                              No indications added
                            </span>
                          )}
                        </div>
                      )}
                    </span>
                  </div>

                  <div className="patient-row-details">
                    <span className="label">Notes</span>
                    <span className="colon">:</span>
                    <span className="value">
                      {isEditing && role !== "Patient" ? (
                        <div className="InEdit">
                          <div className="valueEdit">
                            <span className="value">
                              {/* {prevPatient.notes || "."} */}
                              <div className="notes-container">
                                {Array.isArray(prevPatient.notes) &&
                                prevPatient.notes.length > 0
                                  ? prevPatient.notes.map((note, index) => (
                                      <div key={index} className="note-item">
                                        {note}
                                      </div>
                                    ))
                                  : "."}
                              </div>
                            </span>
                          </div>
                          <textarea
                            name="notes"
                            value={notesText}
                            onChange={(e) => setNotesText(e.target.value)}
                            className="input-edit input-width"
                            placeholder="Add notes here..."
                            rows="3"
                          />
                        </div>
                      ) : (
                        <div className="notes-container-1">
                          {Array.isArray(prevPatient.notes) &&
                          prevPatient.notes.length > 0
                            ? prevPatient.notes.map((note, index) => (
                                <div key={index} className="note-item">
                                  {note}
                                </div>
                              ))
                            : ""}
                        </div>
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PatientProfile;
